import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";

import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import {
    CartResult,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrderForApproval";
import CustomApplicationState from "@thos/Store/CustomApplicationState";
import { getRequestedDeliveryDateState, getThosSubmitForApprovalPONumber } from "@thos/Store/CustomSelector";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess<string>, UpdateCartApiParameter, CartResult>;

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

export const AddRequestedDeliveryDateAndPOToRequest: HandlerType = props => {

    const state = props.getState() as CustomApplicationState;
    const requestedDeliveryDate = getRequestedDeliveryDateState(state);
    const poNumber = getThosSubmitForApprovalPONumber(state);

    if (requestedDeliveryDate && requestedDeliveryDate !== undefined && requestedDeliveryDate !== null) {
        props.apiParameter.cart.requestedDeliveryDate = convertDateToApiFormat(requestedDeliveryDate);
    }
    if (poNumber && poNumber !== undefined && poNumber !== "" && poNumber !== null) {
        props.apiParameter.cart.poNumber = poNumber;
    }
}

addToChainAfter(chain, PopulateApiParameter, AddRequestedDeliveryDateAndPOToRequest);